//export const baseUrl = 'https://nightdistrict.thewebtestlink.xyz/api/';
//export const imgUrl = 'https://nightdistrict.thewebtestlink.xyz';

export const baseUrl = 'https://partners.nightdistrict.co/api/';
export const imgUrl = 'https://partners.nightdistrict.co';
